module.exports = __webpack_public_path__ + "img/album07_17.ebdaba32.jpg";